import React from 'react';
import PropTypes from 'prop-types';
import pillupLogo from '../../assets/logo.png';

const Loader = ({ size = 'medium', text = 'Loading...', className = '' }) => {
    const sizeClasses = {
        small: 'w-12 h-12',
        medium: 'w-16 h-16',
        large: 'w-24 h-24'
    };

    return (
        <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
            <div className="relative">
                {/* Spinning border */}
                <div className={`${sizeClasses[size]} border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin`}></div>

                {/* Logo in center */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <img
                        src={pillupLogo}
                        alt="Pillup Logo"
                        className={`${size === 'small' ? 'w-6 h-6' : size === 'medium' ? 'w-8 h-8' : 'w-12 h-12'} object-contain`}
                    />
                </div>
            </div>

            {text && (
                <p className="mt-4 text-gray-600 font-sans text-sm animate-pulse">
                    {text}
                </p>
            )}
        </div>
    );
};

Loader.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    text: PropTypes.string,
    className: PropTypes.string
};

export default Loader; 